import React from 'react';
import c from 'classnames';

import { Container, useDialog } from '@uncinc/uncinc-react-kitchen-sink';
import { SearchActiveFacetsCounter } from '@uncinc/react-searchkit';

import Button from '../Button';
import Stats from '../SearchGeneral/Stats';

import './style.scss';

export interface DialogProps {
  title: string;
  openButtonTitle: string;
  ctaButtonTitle?: string;
  ctaButtonOnClick?: () => void;
  className?: string;
  children: React.ReactNode;
}

const Dialog: React.FC<DialogProps> = (props) => {
  const {
    title,
    openButtonTitle,
    ctaButtonTitle,
    ctaButtonOnClick,
    className,
    children,
  } = props;

  const {
    dialogIsOpen,
    openDialog,
    closeDialog,
  } = useDialog();

  const classNames = c('Dialog', className, {
    'Dialog--is-open': dialogIsOpen,
  });

  return (
    <>
      <Button
        type="secondary"
        className="Dialog__open-button"
        onClick={() => openDialog()}
      >
        {openButtonTitle}
        <span className="Dialog__ActiveFacetsCounter">
          (<SearchActiveFacetsCounter filterTypes={['type']} />)
        </span>
      </Button>

      <div className={classNames}>
        <Container>
          <div className="row">
            <div className="col-12">
              <header className="Dialog__header">
                <h2 className="asH3">{title}</h2>
              </header>

              <main className="Dialog__content">
                {children}
              </main>

              {ctaButtonTitle && (
                <footer className="Dialog__footer">
                  <Button
                    type="primary"
                    withThemeColor
                    className="Dialog__cta"
                    onClick={() => {
                      closeDialog();

                      if (ctaButtonOnClick) {
                        ctaButtonOnClick();
                      }
                    }}
                  >
                    {ctaButtonTitle}
                    <Stats />
                  </Button>
                </footer>
              )}
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Dialog;
